import { useQueries } from "@tanstack/react-query";

import { workflowLogQueryOptions } from "~/workflow-log/data-source/api/workflow-log-query-options";

export function workflowLogMetadataKey(systemId: string, entryId: string) {
  return JSON.stringify([systemId, entryId]);
}

export function useWorkflowLogMetadata(pairs: { systemId: string; entryId: string }[]) {
  const unique = [
    ...new Map(
      pairs
        .filter((pair) => pair.systemId && pair.entryId)
        .map((pair) => [workflowLogMetadataKey(pair.systemId, pair.entryId), pair]),
    ).values(),
  ];
  return useQueries({
    queries: unique.map((pair) => workflowLogQueryOptions.detail(pair.systemId, pair.entryId)),
    combine: (results) =>
      Object.fromEntries(
        results.map((result, index) => [
          workflowLogMetadataKey(unique[index].systemId, unique[index].entryId),
          {
            data: result.data ? { title: result.data.title, createdById: result.data.createdById } : undefined,
            error: result.error,
            isLoading: result.isLoading,
            isError: result.isError,
          },
        ]),
      ),
  });
}
